/* export const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('default', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }; */

  export const formatDate = (isoString) => {
  const date = new Date(isoString);

  const day = date.toLocaleString('en-US', { day: '2-digit' });
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.toLocaleString('en-US', { year: '2-digit' });
  const time = date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  });

  return `${day} ${month} ${year}, ${time}`;
};
